import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {ParametroFuncao} from 'src/app/funcao/models/parametro-funcao';

@Component({
    selector: 'app-parametro-funcao-valor-checkbox',
    templateUrl: './parametro-funcao-valor-checkbox.component.html',
    styleUrls: ['./parametro-funcao-valor-checkbox.component.scss']
})
export class ParametroFuncaoValorCheckboxComponent implements OnInit {

    @Input() schema: ParametroFuncao = {
        descricao: "",
        endpointOpcoes: "",
        label: "",
        obrigatorio: false,
        ordem: 0,
        parametroVinculado: "",
        parametros: [],
        tamanhoMaximoExibicao: 0,
        tipo: undefined,
        variavel: ""
    };
    @Input() schemaParent: ParametroFuncao = {
        descricao: "",
        endpointOpcoes: "",
        label: "",
        obrigatorio: false,
        ordem: 0,
        parametroVinculado: "",
        parametros: [],
        tamanhoMaximoExibicao: 0,
        tipo: undefined,
        variavel: ""

    };
    @Input() formGroup: FormGroup;
    @Input() value: any;
    @Input() readonly = false;
    @Input() parametrosRegra;

    public required: boolean;

    ngOnInit(): void {
        this.required = this.schema.obrigatorio || this.schemaParent.obrigatorio;
    }
}
